import { render, staticRenderFns } from "./page-documents-edit.vue?vue&type=template&id=25c6e73a&"
import script from "./page-documents-edit.vue?vue&type=script&lang=ts&"
export * from "./page-documents-edit.vue?vue&type=script&lang=ts&"
import style0 from "./page-documents-edit.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports